var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2668 1.66479V44.1079M23.2668 44.1079C19.9236 44.1079 16.721 44.7601 13.7614 45.9533M23.2668 44.1079C26.61 44.1079 29.8126 44.7601 32.7722 45.9533M38.5974 6.51412C33.5885 5.75043 28.4702 5.3555 23.2668 5.3555C18.0634 5.3555 12.9451 5.75043 7.93617 6.51412M38.5974 6.51412C40.8924 6.86402 43.1643 7.29132 45.4111 7.79352M38.5974 6.51412L44.5488 32.9033C44.8255 34.1303 44.3077 35.4316 43.2106 35.8592C41.7699 36.4206 40.2166 36.7265 38.5974 36.7265C36.9783 36.7265 35.425 36.4206 33.9843 35.8592C32.8872 35.4316 32.3693 34.1303 32.6461 32.9033L38.5974 6.51412ZM1.12256 7.79352C3.36927 7.29132 5.64125 6.86402 7.93617 6.51412M7.93617 6.51412L13.8876 32.9033C14.1643 34.1303 13.6464 35.4316 12.5493 35.8592C11.1086 36.4206 9.55536 36.7265 7.93617 36.7265C6.31698 36.7265 4.76375 36.4206 3.32305 35.8592C2.22593 35.4316 1.70807 34.1303 1.98479 32.9033L7.93617 6.51412Z",
    stroke: "#CCA159",
    strokeWidth: 1.66082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.9e4a66d25af75db2525b453bf8c81979.svg";
export { ForwardRef as ReactComponent };